const colors = require('./src/default-theme/default-theme-colors')
const fontSizes = require('./src/default-theme/fontSizes')

module.exports = {
    content: ['./src/**/*.{tsx,ts}'],
    theme: {
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            black: colors.black,
            white: colors.white,
            shade: colors.shade,
            accent: colors.accent,
            info: colors.info,
            success: colors.success,
            warning: colors.warning,
            error: colors.error,
            'deco-one': colors['deco-one'],
            'deco-two': colors['deco-two'],
            text: colors.text,
            border: colors.border,
        },
        fontSize: fontSizes,
        screens: {
            xs: '368px',
            // => @media (min-width: 368px) { ... } >>> Small Phones
            sm: '624px',
            // => @media (min-width: 624px) { ... } >>> Phones - Tablets
            md: '1008px',
            // => @media (min-width: 1008px) { ... } >>> Tablets
            lg: '1264px',
            // => @media (min-width: 1264px) { ... } >>> Laptop
            xl: '1392px',
            // => @media (min-width: 1392px) { ... } >>> Desktop
            '2xl': '1904px',
            // => @media (min-width: 1904px) { ... } >>> Desktop XL
            touch: [{ raw: '(pointer: coarse)' }, { raw: '(hover: none)' }],
            // => @media (pointer: coarse) and (hover: none) >> Touch devices
            'density-md': '1008px',
            'density-lg': [{ raw: '(pointer: coarse)' }, { raw: '(hover: none)' }, { min: '1392px' }],
        },
        boxShadow: {
            none: 'none',
            'drop-sm': '0 0 1px 0 rgba(4,0,61,.04), 0 1px 3px 0 rgba(4,0,61,.08)',
            'drop-md': '0 1px 2px 0 rgba(4,0,61,.04), 0 2px 4px 0 rgba(4,0,61,.04), 0 3px 6px 0 rgba(4,0,61,.04)',
            'drop-lg':
                '0 1px 2px 0 rgba(4,0,61,.04), 0 2px 4px 0 rgba(4,0,61,.04), 0 3px 6px 0 rgba(4,0,61,.04), 0 4px 8px 0 rgba(4,0,61,.04), 0 16px 32px 0 rgba(4,0,61,.04)',
            'inner-sm': 'inset 1px 1px 3px rgba(4, 0, 61, .08), inset 1px 1px 1px rgba(4, 0, 61, .04)',
            'inner-md':
                'inset 1px 1px 2px rgba(4, 0, 61, .04), inset 2px 2px 4px rgba(4, 0, 61, .04), inset 3px 3px 6px rgba(4, 0, 61, .04)',
            'inner-lg':
                'inset 0 1px 2px rgba(4, 0, 61, .04), inset 0 2px 4px rgba(4, 0, 61, .04), inset 0 3px 6px rgba(4, 0, 61, .04), inset 0 4px 8px rgba(4, 0, 61, .04), inset 2px 16px 32px rgba(4, 0, 61, .04)',
        },
        extend: {
            backgroundColor: {
                primary: 'var(--primary-background)',
                secondary: 'var(--secondary-background)',
                interactive: 'var(--interactive-background)',
                active: 'var(--active-background)',
                'accent-default': 'var(--accent-background)',
                disabled: 'var(--disabled-background)',
                'disabled-accent': 'var(--disabled-accent-background)',
                'empty-state': 'var(--empty-state-background)',
                readonly: 'var(--readonly-background)',
                'readonly-accent': 'var(--readonly-accent-background)',
                'timeline-dot': 'var(--timeline-dot-background)',
            },
            fontFamily: { body: 'var(--default-font-family)' },
            spacing: { '1px': '1px' },
            borderRadius: {
                default: 'var(--default-border-radius)',
                '2.5xl': '5rem',
            },
            maxWidth: { 'table-cell': '20rem' },
            minWidth: { 12: '3rem' },
        },
    },
    plugins: [
        require('@tailwindcss/forms')({
            strategy: 'class', // only generate classes
        }),
    ],
}
